module.exports = __webpack_public_path__ + "static/media/symbols.b6a37bf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/action-sprite/svg/symbols.svg
// module id = 452
// module chunks = 1